var filter = function () {
    return function (input) {
        var output = "";
        if (input.lastName != null) {
            output = input.firstName + " " + input.lastName;
        }
        else {
            output = input.firstName;
        }
        if (output.length > 57) {
            return output.substring(0, 57) + "...";
        }
        else {
            return output;
        }
    };
};
var ɵ0 = filter;
export var SubStringFilter = {
    name: 'subStringFilter',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-substring.filter.js.map